import React from 'react';

import ExternalLink from './ExternalLink';
import Svg from './Svg';
import takeMeFishingLogoImage from '../images/take-me-fishing-logo.png';
import vamosAPescarLogoImage from '../images/vamos-a-pescar-logo.png';
import '../styles/footer.scss';

const EmbeddedFooter = () => (
  <div className="footer">
    <div className="footer-attributions">
      <div className="footer-attribution">
        <p>{__('Map provided by')}</p>
        <div className="responsive-image">
          <ExternalLink href={process.env.TAKE_ME_FISHING_BASE_URL}>
            <img
              className="footer-logo footer-logo-tmf"
              src={process.env.LOCALE === 'es' ? vamosAPescarLogoImage : takeMeFishingLogoImage}
              alt={__('Take Me Fishing')}
            />
          </ExternalLink>
        </div>
      </div>
      <div className="footer-attribution">
        <p>{__('With catches data from')}</p>
        <ExternalLink ariaLabel="Fishbrain" href="https://www.fishbrain.com">
          <Svg
            viewBox="0 0 138 26"
            className="footer-logo footer-logo-fib"
            icon="logo"
          />
        </ExternalLink>
      </div>
      <div className="footer-embed">
        <a href="https://www.takemefishing.org/placesmap/">
          {__('Add this map to your website')}
        </a>
      </div>
    </div>
  </div>
);

export default EmbeddedFooter;
